import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import StoreForm from './components/storeForm';
import { updateStore, navigateBack,
  clearValidationErrors, requestDivisionList, requestRegionList,
  requestMarketList, requestStore, requestPricePatchesList, loadPhase,
  fetchInstallersForPrioritization, resetInstallerPrioritization } from 'actionCreators';
import { getWorkroomList, getMarketList, getDivisionList,
  getRegionList, getStoreErrors, getStoreById, getPricePatchesList,
  getStoreInstallerPrioritization } from '../../../../reducers';
import ui from 'redux-ui';
import MediaQuery from 'react-responsive';
import { CUT_POINT } from 'config/constants';
import { filterByDivisionId, filterByRegionId } from '../../../../utils';

class StoreEdit extends Component {
  constructor(props) {
    super(props);
    this.handleSave = this.handleSave.bind(this);
    this.handleDivisionChange = this.handleDivisionChange.bind(this);
    this.handleRegionChange = this.handleRegionChange.bind(this);
    this.handleRemoveNestedErros = this.handleRemoveNestedErros.bind(this);

    this.handleCancel = () => { this.props.dispatch(navigateBack()); };
    this.setSucessMessage = () => {
      this.props.updateUI('successMessage', 'Changes have been saved');
    };

    this.state = {
      regionId: null,
      divisionId: null,
      allLoaded: false,
    };
  }

  componentDidMount() {
    const { dispatch, id } = this.props;
    Promise.all([
      dispatch(requestDivisionList()),
      dispatch(requestPricePatchesList()),
      dispatch(requestStore(id)),
    ]).then(() => {
      this.setState({ allLoaded: true });
      dispatch(fetchInstallersForPrioritization(id));
    });
    /*
      This can be improved by async loading the  divisions & price patches.
      Also take into account that this will fail if one of the promises rejects
      We need to change the convention of rejecting a thunk when
      a failure action is dispatched
    */
  }

  componentDidUpdate(prevProps) {
    const { dispatch, id } = this.props;
    if (!prevProps.store && this.props.store) {
      dispatch(fetchInstallersForPrioritization(id));
    }
  }

  componentWillUnmount() {
    const { dispatch } = this.props;
    dispatch(clearValidationErrors('STORE'));
    dispatch(resetInstallerPrioritization());
  }

  handleRemoveNestedErros(errors) {
    const { dispatch } = this.props;
    dispatch(clearValidationErrors('STORE', errors));
  }

  handleDivisionChange(divisionId) {
    const { dispatch } = this.props;
    dispatch(requestRegionList(divisionId));

    this.setState({
      divisionId,
      regionId: null,
    });
  }

  handleRegionChange(regionId) {
    const { dispatch } = this.props;

    this.setState({ regionId });
    dispatch(requestMarketList(regionId));
  }

  handleSave(store) {
    const { dispatch, phaseId } = this.props;
    dispatch(updateStore(store, this.setSucessMessage));
    // Updates phase in fringe case of viewing phase back to back after editing store
    if (phaseId) dispatch(loadPhase(phaseId));
  }

  render() {
    const { errors, workrooms, divisions, store, regions,
      markets, loadingStore, pricePatches, installerPrioritization } = this.props;
    const { divisionId, regionId } = this.state;
    const filteredRegions = regions.filter(filterByDivisionId(divisionId));
    const filteredMarkets = markets.filter(filterByRegionId(regionId));

    return (
      !loadingStore && this.state.allLoaded ?
        <MediaQuery minWidth={CUT_POINT}>
          <StoreForm
            storeDetails={store}
            errors={errors}
            onSave={this.handleSave}
            onCancel={this.handleCancel}
            onDivisionChange={this.handleDivisionChange}
            onRegionChange={this.handleRegionChange}
            onRemoveNestedErrors={this.handleRemoveNestedErros}
            workrooms={workrooms}
            markets={filteredMarkets}
            regions={filteredRegions}
            divisions={divisions}
            pricePatches={pricePatches}
            installersForPrioritization={installerPrioritization.installers}
            ifiSurfaceTypes={installerPrioritization.surfaceTypes}
          />
        </MediaQuery>
      : <p> Loading...</p>
    );
  }
}

StoreEdit.propTypes = {
  dispatch: PropTypes.func,
  updateUI: PropTypes.func,
  id: PropTypes.number,
  phaseId: PropTypes.number,
  store: PropTypes.object,
  errors: PropTypes.object,
  loadingStore: PropTypes.bool,
  workrooms: PropTypes.array,
  markets: PropTypes.array,
  regions: PropTypes.array,
  divisions: PropTypes.array,
  pricePatches: PropTypes.array,
  installerPrioritization: PropTypes.shape({
    installers: PropTypes.array,
    surfaceTypes: PropTypes.array,
    loading: PropTypes.bool,
  }),
};

const mapStateToProps = (state, ownProps) => {
  const id = Number(ownProps.params.id);
  const store = getStoreById(state)(id);
  const phaseId = state.phase.details.id;

  return {
    id,
    store,
    phaseId,
    errors: getStoreErrors(state) || {},
    loadingStore: store ? store.loading : true,
    workrooms: getWorkroomList(state) || [],
    markets: getMarketList(state),
    regions: getRegionList(state),
    divisions: getDivisionList(state),
    pricePatches: getPricePatchesList(state),
    installerPrioritization: getStoreInstallerPrioritization(state),
  };
};

export default ui()(connect(
  mapStateToProps,
)(StoreEdit));



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/stores/storeEdit.jsx